import {all, call, fork, put} from "redux-saga/effects";
import {apiClient} from 'util/Api'
import {bbStandardRequestHandler} from "../util/bbHelpers";
import {
    FETCH_COMPLIANCE_ASSESSMENTS,
    FETCH_COMPLIANCE_STANDARDS,
    PUT_COMPLIANCE_ASSESSMENT
} from "../constants/ActionTypes";
import {
    fetchComplianceAssessmentsFail, fetchComplianceAssessmentsSuccess,
    fetchComplianceStandardsFail,
    fetchComplianceStandardsSuccess, putComplianceAssessmentFail, putComplianceAssessmentSuccess
} from "../actions";
import {takeEvery, takeLeading} from "@redux-saga/core/effects";

/* ***************************
   Fetching list of all copmliance standards data
   *************************** */

const getComplianceStandardsRequest = async () =>
    await  apiClient.get('/compliance/list', {timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* getComplianceStandardsGenerator() {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "getComplianceStandards";     console.group(`${standardName} Generator...: `);
    // const {customerId, firstName, lastName, email, isManager } = payload;
    const request = yield call(getComplianceStandardsRequest);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, true);

    if (didRequestSucceed) {
        yield put(
            fetchComplianceStandardsSuccess(
                request.data
            )
        );
    } else {
        yield put(fetchComplianceStandardsFail(request));
    }

    console.groupEnd();
}


export function* watchLeadingGetComplianceStandardsData() {
    yield takeLeading(FETCH_COMPLIANCE_STANDARDS, getComplianceStandardsGenerator);
}

/* ***************************
   Fetching list of assessments for a given customer and standard
   *************************** */

const getComplianceAssessmentsRequest = async (customerId, standardId) =>
    await  apiClient.get(`/compliance/customer/${customerId}/standard/${standardId}`, {timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* getComplianceAssessmentsGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "getComplianceAssessments";     console.group(`${standardName} Generator...: `);
    const {customerId, standardId } = payload;
    const request = yield call(getComplianceAssessmentsRequest, customerId, standardId);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, false);

    if (didRequestSucceed) {
        yield put(
            fetchComplianceAssessmentsSuccess(
                {
                    inboundData: request.data,
                    customerId: customerId,
                    standardId: standardId
                }
            )
        );
    } else {
        yield put(fetchComplianceAssessmentsFail(request));
    }

    console.groupEnd();
}


export function* watchLeadingGetComplianceAssessmentsData() {
    yield takeLeading(FETCH_COMPLIANCE_ASSESSMENTS, getComplianceAssessmentsGenerator);
}

/* ***************************
   Fetching list of assessments for a given customer and standard
   *************************** */

const putComplianceAssessmentRequest = async (customerId, standardId, controlId, assessmentStatusId, assessmentSourceId, doPropagate = 0) =>
    await  apiClient.post(`/compliance/customer/${customerId}/standard/${standardId}`,{
            Control: controlId,
            ["Assessment Status"]: assessmentStatusId,
            ["Assessment Source"]: assessmentSourceId,
            Propagate: doPropagate
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* putComplianceAssessmentGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "putComplianceAssessment";     console.group(`${standardName} Generator...: `);
    const {
        customerId,
        standardId,
        controlId,
        assessmentStatusId,
        assessmentSourceId,
    } = payload;
    const request = yield call(putComplianceAssessmentRequest, customerId, standardId, controlId, assessmentStatusId, assessmentSourceId);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(
            putComplianceAssessmentSuccess(
                {
                    inboundData: request.data,
                    customerId: request.data.CustomerId,
                    standardId: standardId,
                    controlId: request.data.Control,
                    assessmentId: request.data.Id,
                }
            )
        );
    } else {
        yield put(putComplianceAssessmentFail(request));
    }

    console.groupEnd();
}


export function* watchEveryPutComplianceAssessmentData() {
    yield takeEvery(PUT_COMPLIANCE_ASSESSMENT, putComplianceAssessmentGenerator);
}

/* ***************************
   root Saga
   *************************** */

export default function* rootSaga() {
    yield all([
        fork(watchLeadingGetComplianceStandardsData),
        fork(watchLeadingGetComplianceAssessmentsData),
        fork(watchEveryPutComplianceAssessmentData)
    ]);
}